var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "structure"
  }, [_c('div', {
    staticClass: "department"
  }, [_c('div', {
    staticClass: "search"
  }, [_c('Input', {
    attrs: {
      "title": _vm.language != 'en-US' ? (_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("arczi710", "\u67E5\u2018${org.name || \"\u4F01\u4E1A\"}\u2019\u4E0B\u7684\u624B\u673A\u53F7\u3001\u59D3\u540D\u3001\u5DE5\u53F7\u3001\u90AE\u7BB1", {
        "org.name || '\u4F01\u4E1A'": _vm.org.name || $t("dv7d2", "企业")
      })) : $t("dp4825i", "查询企业下的手机号、姓名、工号、邮箱"),
      "search": "",
      "placeholder": _vm.language != 'en-US' ? (_vm.$store && _vm.$store.state && _vm.$store.state.site && _vm.$store.state.site.language || _vm.$i18n && _vm.$i18n.locale, $t("arczi710", "\u67E5\u2018${org.name || \"\u4F01\u4E1A\"}\u2019\u4E0B\u7684\u624B\u673A\u53F7\u3001\u59D3\u540D\u3001\u5DE5\u53F7\u3001\u90AE\u7BB1", {
        "org.name || '\u4F01\u4E1A'": _vm.org.name || $t("dv7d2", "企业")
      })) : $t("dp4825i", "查询企业下的手机号、姓名、工号、邮箱"),
      "clearable": ""
    },
    on: {
      "on-search": _vm.onSearchList
    },
    model: {
      value: _vm.search.value,
      callback: function ($$v) {
        _vm.$set(_vm.search, "value", $$v);
      },
      expression: "search.value"
    }
  })], 1), _c('OSTree', {
    ref: "STree",
    attrs: {
      "org": _vm.org
    },
    on: {
      "clear": _vm.clearSearchValue,
      "changeOrg": _vm.changeOrg
    }
  })], 1), _c('div', {
    staticClass: "list"
  }, [_c('List', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showList,
      expression: "showList"
    }],
    ref: "list",
    attrs: {
      "org": _vm.org,
      "inviteLoading": _vm.loading,
      "searchValue": _vm.search.value
    },
    on: {
      "clear": _vm.clearSearchValue,
      "addUser": function ($event) {
        return _vm.changeAction('2');
      },
      "editUser": _vm.changeUser,
      "detailUser": _vm.changeDetail,
      "smsGot": _vm.initialInviteSms
    }
  }), _vm.showUserMessage ? _c('UserJoin', {
    attrs: {
      "item": _vm.user.item,
      "org": _vm.org
    },
    on: {
      "update": function ($event) {
        return _vm.changeAction('1', true);
      },
      "cancel": function ($event) {
        return _vm.changeAction('1');
      }
    }
  }, [_vm._v($t("e81syc4", "添加用户"))]) : _vm._e(), _vm.showUserDetail ? _c('UserDetail', {
    attrs: {
      "item": _vm.user.item,
      "org": _vm.org,
      "loading": _vm.loading
    },
    on: {
      "cancel": function ($event) {
        return _vm.changeAction('1', true);
      },
      "editUser": _vm.changeUser,
      "update": function ($event) {
        return _vm.changeAction('1', true);
      },
      "smsGot": _vm.initialInviteSms
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };